import { Link } from "react-router-dom";

/**
 * El "¿Olvidaste tu contraseña?" que va a la derecha del label. Es un
 * componente y no dos líneas de JSX porque aparecerá también en el flujo
 * de cambiar contraseña desde el perfil, y ahí debe verse igual.
 */
export function ForgotPasswordLink() {
  return (
    <Link
      to="/forgot-password"
      className="text-[11px] text-ds-purple transition hover:text-ds-ink-3"
    >
      ¿Olvidaste tu contraseña?
    </Link>
  );
}
